import { render, staticRenderFns } from "./CreateCompanyTypePopup.vue?vue&type=template&id=4eba0089"
import script from "./CreateCompanyTypePopup.vue?vue&type=script&lang=js"
export * from "./CreateCompanyTypePopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports